import {cloneDeep, get} from "lodash";
import {getString, getArray} from "Core/helpers/data";
import {MyTicketsItemCommentsDataObject, MyTicketsItemDataObject} from "../dataObjects";
import {getDate, STANDARD_DATE_TIME_FORMAT} from "Core/helpers/datetime";

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {MyTicketsItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new MyTicketsItemDataObject(
		getString(result, 'id'),
		getString(result, 'ticketId'),
		getString(result, 'status'),
		getString(result, 'firstName'),
		getString(result, 'lastName'),
		getDate(get(result, 'creationDate', null), STANDARD_DATE_TIME_FORMAT.ISO_DATE_TIME_S),
		getArray(result, 'comments').map(c => new MyTicketsItemCommentsDataObject(
			getString(c, 'id'),
			getDate(get(c, 'creationDate', null), STANDARD_DATE_TIME_FORMAT.ISO_DATE_TIME_S),
			getString(c, 'creator'),
			getString(c, 'subject'),
			getString(c, 'name'),
			getString(c, 'phoneNumber'),
			getString(c, 'body')
		))
	);

	return result;
}